import { getAppConfig } from '../../config';
import { Userpilot } from 'userpilot';

let isInitialized = false;

export interface IUserPilotUserTraits {
    companyID: string;
    name: string;
    username: string;
}

/**
 * Initializes Userpilot using the appConfig.
 */
const init = () => {
    const userPilotToken = getAppConfig().userPilotToken;

    if (!userPilotToken) {
        return;
    }

    if (isInitialized) {
        return;
    }

    Userpilot.initialize(userPilotToken);

    isInitialized = true;
};

/**
 * This function is used to filter out userpilot calls for specific userIds.
 * Workaround for now to lower the number of calls to userpilot. License currently supports 10000 users per month
 * @param userId unique identifier for the user
 * @returns boolean indicating if the userId is allowed or not
 */
const isUserIdAllowed = (userId: number) => {
    if (userId % 3 === 0) {
        return true;
    }
    return false;
};

/**
 * Identify the user to userpilot
 * @param userId unique identifier for the user
 * @param traits additional user traits about the user
 */
export const identifyUserPilot = (userId: number, traits: IUserPilotUserTraits) => {
    if (!isUserIdAllowed(userId)) {
        return;
    }

    init();
    if (isInitialized) {
        Userpilot.identify(String(userId), traits);
    }
};

/**
 * Remove the user from userpilot when user logs out
 */
export const removeUserPilot = () => {
    isInitialized = false;
    Userpilot.identify('', {
        companyID: '',
        name: '',
        username: '',
    });
};
